import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { IDataRoleInfo } from '../../../ts/models/IDataRoleInfo';
import { DetailsTooltipStyles } from '../CardView/DetailsTooltipStyles';
import { MarkupField } from './Elements/MarkupField';
import { Name } from './Elements/Name';
import { RelatedEntity } from './Elements/RelatedEntity';
import { Timestamp } from './Elements/Timestamp';
import { Tooltip } from './Elements/Tooltip';
import { User } from './Elements/User';
import { ContentTooltipProps, getProjectLink, TooltipDescriptionTestId } from './TooltipHelper';

export function DataRoleTooltip(props: ContentTooltipProps): JSX.Element {
  const { content, urls } = props;
  const projectLink = getProjectLink((props.content as IDataRoleInfo).project, urls);

  return (
    <Tooltip>
      <Name name={content.name} />
      <MarkupField markup={props.content.description}
                  testId={TooltipDescriptionTestId}
                  extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
      {!props.inProjectSpace && <RelatedEntity label={Messages.project()} link={projectLink} /> }
      <User user={props.content.owner} label={Messages.owner()} urls={urls} />
      <Timestamp label={Messages.modified()} value={props.content.updatedAt} />
    </Tooltip>
  );
}
